/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import DataTableFilter from "../Common/DataTableFilter";
import { useNavigate } from "react-router-dom";
import { WebSocketContext } from "../../App";
import { ADD_AGE_VALUE_REPORT, UPDATE_AGE_VALUE_REPORT } from "../Shared/constant";
import { ClearFormSetFutios } from "../../redux/actions/adminActions";
import wsSend_request from "../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import CommonTable from "../Common/CommonTable";

const AgeValue = (props) => {
    const { AgeValueList, device_id, selfInfo } = useSelector((state) => state.adminReducers);
    const { websocket } = useContext(WebSocketContext);
    const Navigate = useNavigate();
    const Dispatch = useDispatch();
    const [ userSearch, setUserSearch ] = useState("");
    const [ userType, setUserType ] = useState("");
    const [ userLimit, setUserLimit ] = useState(10);
    const [ currentPage, setCurrentPage ] = useState(1);
    const PermissionsAccess = selfInfo?.user?.permissions_access;

    // page change
    const currentFunction = (page) => {
        setCurrentPage(page);
    };

    // select user type
    const SelectUserTypeFnct = (e) => {
        setUserType(e.target.value);
        setCurrentPage(1);
    };

    // api calling
    const APICall = () => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.ReSells[3]?.Edit || PermissionsAccess?.ReSells[3]?.View)) {
            let param = { 
                "transmit": "broadcast", 
                "url": "refurbished_age_list",
                "request" : { 
                    "limit" : userLimit,
                    "page_no" : currentPage, 
                    "order_by" :"-updated_at"
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        };
    };

    // when page load api calling
    useEffect(() => {
        APICall();
    }, [ websocket, userSearch, userType, currentPage, userLimit ]);

    // create points
    const cmnFnct = () => {
        Navigate(ADD_AGE_VALUE_REPORT);
    };

    useEffect(() => {
        Dispatch(ClearFormSetFutios({
            url:"",
            action:false
        }));
    }, []);

    // TABLE COLUMNS ARRAY
    const TableColumns = [
        { key: 'min_day', label: 'Min Day', type: "label_day_price", sort: "", isCollapsable: false },
        { key: 'max_day', label: 'Max Day', type: "label_day_price", sort: "", isCollapsable: false },
        { key: 'max_percentage', label: 'Max %', type: "label", sort: "", isCollapsable: false },
        { key: 'age_score', label: 'Age Score', type: "label", sort: "", isCollapsable: false },
    ];

    return(<section className="Main_section">
        <DataTableFilter 
            filterType={""}
            searchType={"Point Name"}
            userSearch={userSearch}
            setUserSearch={setUserSearch}
            userType={userType} 
            setUserType={setUserType}
            userLimit={userLimit} 
            setUserLimit={setUserLimit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            SelectUserTypeFnct={SelectUserTypeFnct}
            buttonvisible={(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.ReSells[3]?.Edit) ? true : false}
            ButtonSet={{
                buttontitle: "Create Age Value",
                function: cmnFnct
            }}
            searchdisable={false}
            ActiveInactiveFilter={false}
        />
        {/* COMMON TABLE */}
        <CommonTable 
            isTableAllow={true}
            style={{
                height: parseInt(AgeValueList?.pagination?.total_records) === AgeValueList?.list?.length ? "calc(100vh - 140px)" : parseInt(AgeValueList?.pagination?.total_records) > 10 ? "calc(100vh - 175px)" : "calc(100vh - 140px)"
            }}
            srNumber={{
                clickable: false,
                events: ""
            }}
            isCollapsable={false}
            tabName={"user-list"} // TAB URL
            PaginationCurrentPage={currentPage} // TAB CURRENT PAGE
            PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
            TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
            OrderList={AgeValueList} // CATEGORY LIST
            Pagination={AgeValueList?.pagination} // CURRENT TAB PAGINATION
            EditAccess={(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.ReSells[3]?.Edit)} // EDITABLE ACCESS STATE
            isActionColumnAvailable={{
                isShow: (selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.ReSells[3]?.Edit),
                label: "edit_delete",
                naviagte: `${UPDATE_AGE_VALUE_REPORT}/`
            }}
            isActionTwoColumnAvailable={{
                isShow: false,
                url: "",
            }}
            isOdiFilterRowColorsAllow={false}
        />
    </section>)
}

export default AgeValue;